import { Box, BoxProps, Spacer, Text, TextProps } from '@jfs/ui-new'
import { Icon } from '@jfs/ui-new/src/comps/IconNew'

interface SubTitleProps {
  rrnNo?: string
  message: string
  status?: string
}

export const TransactionStatus = ({ rrnNo, message, status }: SubTitleProps) => {
  const statusText = status === 'SUCCESS' ? message : 'Transaction Failed'

  return (
    <Box {...styles.container} backgroundColor={status === 'SUCCESS' ? 'PRIMARY' : 'ERROR'}>
      <Box {...styles.tickStyle}>
        <Icon
          id={status === 'SUCCESS' ? 'TICKMARK' : 'CLOSE'}
          color={status === 'SUCCESS' ? 'PRIMARY' : 'ERROR'}
          size={20}
        />
      </Box>
      <Spacer size={16} direction="vertical" />
      <Text {...styles.title}>{statusText}</Text>
      <Spacer size={4} direction="vertical" />
      {rrnNo && rrnNo !== 'null' && <Text {...styles.subTitle}>{`RRN NO.: ${rrnNo}`}</Text>}
    </Box>
  )
}

const styles = {
  container: {
    backgroundColor: 'BRAND_PRIMARY_GREEN',
    justifyContent: 'center',
    alignItems: 'center',
    pt: 12,
    pb: 32,
  } as BoxProps,
  tickStyle: {
    backgroundColor: 'WHITE',
    width: 36,
    height: 36,
    borderRadius: 36,
    justifyContent: 'center',
    alignItems: 'center',
  } as BoxProps,
  title: {
    fontFamily: 'jioType-medium',
    fontSize: 16,
    lineHeight: 22,
    textAlign: 'center',
    color: 'WHITE',
  } as TextProps,
  subTitle: {
    fontFamily: 'jioType-medium',
    fontSize: 12,
    textAlign: 'center',
    color: 'WHITE',
    opacity: 0.7,
  } as TextProps,
}
